export default __webpack_public_path__ + "static/media/cdlog.c65b6075.jpg";